/**
 * Page Wrapper Component Exports
 *
 * @since 1.0.0
 */

export { PageWrapper } from './component';
export type { PageWrapperProps } from './types';
